import { Form, Input, InputNumber, Select, Tag, Typography } from 'antd'
import { AttachmentUpload, type AttachmentDescriptor } from '@/features/files/index.ts'
import { RentalContractFields } from './rental-contract-fields.tsx'
import type { BusinessOption } from './service-order-form.types.ts'
import { ServicePricingFields } from './service-term-fields.tsx'

export function ServiceOrderEditItemFields({
  businessLoading,
  businessOptions,
  disabled,
  initialAttachmentFiles,
  onBusinessChange,
  onBusinessSearch
}: {
  businessLoading: boolean
  businessOptions: BusinessOption[]
  disabled: boolean
  initialAttachmentFiles: AttachmentDescriptor[]
  onBusinessChange: (value: number) => void
  onBusinessSearch: (value: string) => void
}) {
  return (
    <section
      className="border-border bg-surface scroll-mt-24 rounded-xl border p-5 shadow-xs"
      id="section-service-items"
    >
      <div className="mb-5 flex items-start justify-between gap-3">
        <div>
          <Typography.Title className="mb-1!" level={5}>
            服务业务
          </Typography.Title>
          <Typography.Text type="secondary">当前页面只编辑这一条服务订单的业务、金额、附件和备注。</Typography.Text>
        </div>
        <Tag color="blue">单个订单</Tag>
      </div>

      <div className="grid grid-cols-1 gap-x-6 lg:grid-cols-[minmax(0,2fr)_minmax(14rem,1fr)_minmax(14rem,1fr)]">
        <Form.Item label="服务业务" name="businessId" rules={[{ message: '请选择服务业务', required: true }]}>
          <Select
            disabled={disabled}
            loading={businessLoading}
            onChange={onBusinessChange}
            options={businessOptions}
            placeholder="请选择增值业务"
            showSearch={{ onSearch: onBusinessSearch, filterOption: false }}
          />
        </Form.Item>
        <ServicePricingFields disabled={disabled} />
        <Form.Item
          label="成本（非必填）"
          name="costAmount"
          rules={[{ message: '成本不能小于 0', min: 0, type: 'number' }]}
        >
          <InputNumber className="w-full" disabled={disabled} min={0} precision={2} prefix="¥" />
        </Form.Item>
      </div>
      <Form.Item label="附件" name="fileIds">
        <AttachmentUpload
          purpose="serviceAttachment"
          disabled={disabled}
          initialFiles={initialAttachmentFiles}
          maxCount={20}
        />
      </Form.Item>
      <Form.Item label="备注" name="note">
        <Input.TextArea
          disabled={disabled}
          maxLength={5000}
          placeholder="补充本项服务说明（选填）"
          rows={3}
          showCount
        />
      </Form.Item>
      <RentalContractFields service />
    </section>
  )
}
